/**
 * Created by nijin on 28/12/16.
 */
/**
 * Created by nijin on 19/12/16.
 */
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {WizardContentComponent} from "./wiz-content.component";
import {ThingsService} from "../../things.service";

@Component({
  selector: 'nuc-wiz-cmn-header',
  templateUrl: './wiz-cmn-header.component.html',
  styles:[
    `	.commonHeader{
	        background-color: #f0f1f4;
	        padding: 25px 45px;
	        padding-right: 250px;
	        position: fixed;
		    right: 0;
		    left: 280px;
		    top: 60px;
		    z-index: 13;
		}
		.commonHeader h2{
          	font-size: 22px;
          	color: #576187;
	        margin: 0;
	        font-weight: 600;
	        margin-bottom: 10px;
	        	display: inline-block;
	        	vertical-align: middle;
		}		
		.commonHeader p{
          	color: #9a9ead;
          	margin: 0;
		}
		.commonHeader button{
			min-width: 100px;
			margin-right: 10px;
			margin-bottom: 0;
		}
		
		.commonHeader button.btn-secondary-small{
			margin-left: 10px;
		    margin-bottom: 9px;
		    padding: 3px 10px;
		    min-width: 80px;
		    font-size: 13px;
		}

		.commonHeader .btn-group-1{
			position: absolute;
			right: 10px;
			top: 50%;
			transform: translateY(-50%);
		}
		@media(max-width: 1366px){
			.commonHeader{
				padding: 20px 45px;
	        	padding-right: 250px;
			}
			.commonHeader p{
				font-size: 13px;
			}
			.commonHeader h2{
				font-size: 20px;
			}
		}
		@media(max-width: 767px){
			.commonHeader{
		        padding: 20px 30px;
			}
			.commonHeader .btn-group-1{
				position: relative;
				top: 0;
				right: 0;
				transform: none;
			}
			.commonHeader .btn-group-1 button:last-child{
				margin-right: 0;
			}
			.commonHeader h2{
				display: inline-block;
			}
			.commonHeader p{
				margin-bottom: 10px;
			}
		}
		.rowcontainer{padding: 2px;}
`]
})
export class ThingsCommonHeaderComponent implements OnInit {
  @Input() activeStep: WizardContentComponent;
  @Input() next : WizardContentComponent;
  @Input() previous: WizardContentComponent;
  @Output() changeStep: EventEmitter<WizardContentComponent> = new EventEmitter<WizardContentComponent>();
  @Output() preview: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit() { }

  goToNext(){
    if(this.activeStep.wizardContent.canMoveForward()){
      this.activeStep.wizardContent.onValidState(this.changeStep, this.next);
    }
    else{
      this.activeStep.wizardContent.onInvalidState();
    }

  }

  viewPreview(){
    this.activeStep.wizardContent.preview();
  }

  goToPrev(){
    this.changeStep.emit(this.previous);
  }

}



// WEBPACK FOOTER //
// ./src/app/things/shared/wizard/wiz-cmn-header.ts